import { Order } from '../types/orders';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const getProductDetails = async (productId: string) => {
  try {
    const productDoc = await getDoc(doc(db, 'products', productId));
    if (productDoc.exists()) {
      return productDoc.data();
    }
  } catch (error) {
    console.error('Erro ao buscar detalhes do produto:', error);
  }
  return null;
};

export const mapOrderToWarehouse = async (order: Order) => {
  // Determinar o endereço correto baseado no tipo de pedido
  let shippingAddress = order.shippingAddress;

  // Para pedidos do WooCommerce
  if (order.source === 'woocommerce' && order.sourceData) {
    shippingAddress = {
      name: `${order.sourceData.shipping?.first_name || ''} ${order.sourceData.shipping?.last_name || ''}`.trim(),
      address: order.sourceData.shipping?.address_1,
      address2: order.sourceData.shipping?.address_2,
      city: order.sourceData.shipping?.city,
      postalCode: order.sourceData.shipping?.postcode,
      country: order.sourceData.shipping?.country,
      phone: order.sourceData.shipping?.phone || order.sourceData.billing?.phone,
      email: order.sourceData.billing?.email
    };
  }
  // Para vendas manuais, usar o endereço como está
  else if (order.source === 'manual') {
    shippingAddress = {
      name: order.shippingAddress?.name || '',
      address: order.shippingAddress?.address || '',
      city: order.shippingAddress?.city || '',
      postalCode: order.shippingAddress?.postalCode || '',
      country: 'PT',
      phone: order.shippingAddress?.phone || '',
      email: order.customer?.email || ''
    };
  }

  // Montar o endereço completo
  const addressParts = [
    shippingAddress?.address || shippingAddress?.street,
    shippingAddress?.city
  ].filter(Boolean);
  
  const deliveryAddress = addressParts.join(' ');

  // Verificar se tem NIF para definir want_invoice
  const hasValidTaxNumber = shippingAddress?.taxNumber && shippingAddress.taxNumber.length > 0;

  // Buscar detalhes de todos os produtos
  const productsWithDetails = await Promise.all(order.items.map(async (item) => {
    // Extrair o ID do produto da string composta (ID-companyId)
    const [productId] = item.productId?.split('-') || [''];
    console.log('Produto original:', item.productId);
    console.log('ID extraído:', productId);
    
    if (!productId) {
      console.error('ID do produto não encontrado:', item);
      return item;
    }

    const productDetails = await getProductDetails(productId);
    console.log('Detalhes do produto:', productDetails);
    
    if (!productDetails) {
      console.error('Detalhes do produto não encontrados:', productId);
      return item;
    }

    return {
      ...item,
      details: productDetails
    };
  }));

  return {
    order_status_id: "129970",
    date_add: Math.floor(Date.now() / 1000).toString(),
    user_comments: `PEDIDO Nº ${order.orderNumber || order.id} DO EMTUACASA.PT\n${order.comments?.join('\n') || ''}`,
    admin_comments: '',
    phone: shippingAddress?.phone || '',
    email: shippingAddress?.email || order.customer?.email || '',
    user_login: shippingAddress?.name || '',
    currency: "EUR",
    payment_method: order.paymentMethod || "Transferência Bancária",
    payment_method_cod: "0",
    paid: "1",
    delivery_method: "Expedited shipping",
    delivery_price: (order.shippingCost || 0).toString(),
    delivery_fullname: shippingAddress?.name || '',
    delivery_company: '',
    delivery_address: deliveryAddress,
    delivery_city: shippingAddress?.city || '',
    delivery_state: shippingAddress?.district || '',
    delivery_postcode: shippingAddress?.postalCode || '',
    delivery_country_code: 'PT',
    delivery_point_id: '',
    delivery_point_name: '',
    delivery_point_address: '',
    delivery_point_postcode: '',
    delivery_point_city: '',
    invoice_fullname: shippingAddress?.name || '',
    invoice_company: '',
    invoice_nip: shippingAddress?.taxNumber || '',
    invoice_address: deliveryAddress,
    invoice_city: shippingAddress?.city || '',
    invoice_state: shippingAddress?.district || '',
    invoice_postcode: shippingAddress?.postalCode || '',
    invoice_country_code: 'PT',
    want_invoice: hasValidTaxNumber ? "1" : "0",
    extra_field_1: '',
    extra_field_2: '',
    custom_extra_fields: {},
    products: productsWithDetails.map(item => {
      console.log('Mapeando produto:', item);
      return {
        storage: "db",
        storage_id: "bl_1",
        product_id: item.details?.baselinker_id || '',
        variant_id: 0,
        name: item.name,
        sku: item.details?.sku || '',
        ean: item.details?.ean || '',
        price_brutto: item.price,
        tax_rate: 23,
        quantity: item.quantity,
        weight: item.details?.weight || 0.04 // Peso padrão em kg se não especificado
      };
    })
  };
};

export const sendToWarehouse = async (order: Order): Promise<{ success: boolean; message: string; orderId?: string }> => {
  try {
    const warehouseData = await mapOrderToWarehouse(order);
    
    // URL direta da API
    const apiUrl = 'https://api.shippix.pt/createorder.php';

    console.log('Enviando dados para:', apiUrl);
    console.log('Dados:', JSON.stringify(warehouseData, null, 2));

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(warehouseData)
    });

    console.log('Status da resposta:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Erro da API:', errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('Resposta da API:', result);

    if (result.status === 'SUCCESS') {
      return {
        success: true,
        message: `Pedido enviado com sucesso para o armazém`,
        orderId: result.order_id
      };
    } else {
      throw new Error(result.error || 'Erro desconhecido');
    }
  } catch (error) {
    console.error('Erro ao enviar para o armazém:', error);
    return {
      success: false,
      message: `Erro ao enviar para o armazém: ${error instanceof Error ? error.message : 'Erro desconhecido'}`
    };
  }
};
